/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export interface ProviderDetails {
  status: "provided";
  full_name: string;
  phone?: string | null;
  street_address?: string | null;
  street_address_2?: string | null;
  city?: string | null;
  state?: string | null;
  zip_code?: string | null;
  sharing_consent: boolean;
  responded_at?: string | null;
}
